exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-error[data-v-46371015] {\n  font-size: .9em;\n  color: #db3a4a;\n}\n", ""]);

// exports
